import React from 'react';
import { useTheme } from '../../context/ThemeContext';

export const SidebarDown = ({isActive}) => {
  const { isDarkMode } = useTheme();
  const stroke = isDarkMode ? "#d8d8ed" : "#525383";
  const fill = isDarkMode ? (isActive ? "#d8d8ed" : "none") : (isActive ? "#525383" : "none");
  
  return (
    <svg width="16" height="16" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="138" width="136" height="136" rx="7" transform="rotate(-90 2 138)" stroke={stroke} strokeWidth="4"/>
      <rect x="2" y="138" width="56" height="136" rx="3" transform="rotate(-90 2 138)" stroke={stroke} strokeWidth="4" fill={fill}/>
    </svg>
  );
};
